import { useQuery } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { device } from "web_myplann/Utils/device";

const listSavedDocumentIds = async (): Promise<number[] | null> => {
	try {
		const response = await device.listSavedAttachments();
		return response.payload.success ? response.payload.savedDocumentIds : null;
	} catch {
		return null;
	}
};

export const useSavedDocumentIdsQuery = () => {
	return useQuery({
		queryKey: DocumentKeys.saved,
		queryFn: listSavedDocumentIds,
		enabled: Boolean(window.ReactNativeWebView),
		refetchOnWindowFocus: true,
		meta: { persist: false },
	});
};
